import { render, staticRenderFns } from "./orderTabs.vue?vue&type=template&id=413981f1"
import script from "./orderTabs.vue?vue&type=script&lang=js"
export * from "./orderTabs.vue?vue&type=script&lang=js"
import style0 from "./orderTabs.vue?vue&type=style&index=0&id=413981f1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports